import "./index.css"
import AirDropCard from "./AirDropCard";
import SimpleAirdropCard from "./SimpleAirdropCard";

export default function PageTwo() {

    return (
        <div>
            <div class="mt-5 ms-5">
                <br/>
                <br/>
                <br/>
                <h1 class="text-light">AirDrop</h1>
                <span class="text-light">Here you can get your own music NFT</span>
            </div>
            <div className="container">
            <div className="row mt-5 mb-5">
                <div class="col">
                    <SimpleAirdropCard imgSrc={require("../../images/airdrop1.png")}/>
                </div>
                <div class="col">
                    <SimpleAirdropCard imgSrc={require("../../images/airdrop2.png")}/>
                </div>
                <div class="col">
                    <SimpleAirdropCard imgSrc={require("../../images/airdrop3.png")}/>
                </div>
                <div class="col">
                    <SimpleAirdropCard imgSrc={require("../../images/airdrop4.png")}/>
                </div>
            </div>
            </div>

        </div>
    )

}